const initialState = {
    pharmacyViewDetailsView:[],
    pharmacyPermissionsView:{},
    pharmacyListsView: [],
    pharmacyListsIdView:[],
    pharmacyStatusView: [],
    changedPharmacyStatusView: [],
    loadingPharmacyView: false,
    errorsPharmacyView: {},
    pharmacyIdsView:"",
    pharmacyCountView:0,
}

const  pharmacyReducerView = (state = initialState, action) => {
    switch (action.type) {
        case "GET_PHARMACYLIST_VIEW_PENDING":
        case "ADD_PHARMACY_BASIC_VIEW_PENDING":
        case "ADD_PHARMACY_DL_VIEW_PENDING":
        case "ADD_PHARMACY_OWNER_VIEW_PENDING":
        case "ADD_PHARMACIST_VIEW_PENDING":
        case "ADD_GST_PAN_VIEW_PENDING":
        case "ADD_LOCATED_HOSPITAL_VIEW_PENDING":
        case "ADD_PHARMACY_AlERT_VIEW_PENDING":
        case "ADD_BACK_LIST_VIEW_PENDING":
        case "ADD_GRIEVANCE_VIEW_PENDING":
        case "UPDATE_PHARMACY_VIEW_PENDING":
        case "UPDATE_PHARMACY_STATUS_VIEW_PENDING":
        case "UPDATE_PHARMACY_BASIC_VIEW_PENDING":
        case "DELETE_PHARMACY_VIEW_PENDING":
        case "GET_PHARMACYLISTBYID_VIEW_PENDING":
        case "GET_PHARMACYVIEWLISTBYID_VIEW_PENDING":
            return { ...state, loadingPharmacyView: true , errorsPharmacyView: {}  };

        case "GET_PHARMACYLIST_VIEW_FULFILLED":
            return {
                ...state,
                loadingPharmacyView: false,
                pharmacyListsView: action.payload,
                pharmacyCountView: action.count,
                pharmacyPermissionsView:action.permissions,
            };

        case "ADD_PHARMACY_BASIC_VIEW_FULFILLED":
            return {
                ...state,
                loadingPharmacyView: false,
                changedPharmacyStatusView: action.payload,
                //pharmacyIdsView:action.payload?.data?.id  || state.pharmacyIdsView,
                errorsPharmacyView: {},
            };
        case "GET_PHARMACYVIEWLISTBYID_VIEW_FULFILLED":
            return {
                ...state,
                loadingPharmacyView: false,
                pharmacyViewDetailsView: action.payload,
            };
            case "UPDATE_PHARMACY_BASIC_VIEW_FULFILLED":
                return {
                    ...state,
                    loadingPharmacyView: false,
                    changedPharmacyStatusView: action.payload,
                    //pharmacyIdsView:action.payload?.data?.id  || state.pharmacyIdsView,
                    errorsPharmacyView: {},
                };    

        case "ADD_PHARMACY_DL_VIEW_FULFILLED":
            return {
                ...state,
                loadingPharmacyView: false,
                changedPharmacyStatusView: action.payload,
                //pharmacyIdsView:action.payload?.data?.id  || state.pharmacyIdsView,
                errorsPharmacyView: {},
            };

        case "ADD_PHARMACY_OWNER_VIEW_FULFILLED":
            return {
                ...state,
                loadingPharmacyView: false,
                changedPharmacyStatusView: action.payload,
                //pharmacyIdsView:action.payload?.data?.id  || state.pharmacyIdsView,
                errorsPharmacyView: {},
            };

        case "ADD_PHARMACIST_VIEW_FULFILLED":
            return {
                ...state,
                loadingPharmacyView: false,
                changedPharmacyStatusView: action.payload,
                //pharmacyIdsView:action.payload?.data?.id  || state.pharmacyIdsView,
                errorsPharmacyView: {},
            };

        case "ADD_GST_PAN_VIEW_FULFILLED":
            return {
                ...state,
                loadingPharmacyView: false,
                changedPharmacyStatusView: action.payload,
                //pharmacyIdsView:action.payload?.data?.id  || state.pharmacyIdsView,
                errorsPharmacyView: {},
            };

        case "ADD_LOCATED_HOSPITAL_VIEW_FULFILLED":
            return {
                ...state,
                loadingPharmacyView: false,
                changedPharmacyStatusView: action.payload,
                //pharmacyIdsView:action.payload?.data?.id  || state.pharmacyIdsView,
                errorsPharmacyView: {},
            };
            
            case "ADD_PHARMACY_AlERT_VIEW_FULFILLED":
                console.log("action.payload",action.payload);
                return {
                    ...state,
                    loadingPharmacyView: false,
                    changedPharmacyStatusView: action.payload,
                    //pharmacyIdsView:action.payload?.data?.id  || state.pharmacyIdsView,
                errorsPharmacyView: {},
                };
            case "ADD_BACK_LIST_VIEW_FULFILLED":
                return {
                    ...state,
                    loadingPharmacyView: false,
                    changedPharmacyStatusView: action.payload,
                    //pharmacyIdsView:action.payload?.data?.id  || state.pharmacyIdsView,
                errorsPharmacyView: {},
                };
            case "ADD_GRIEVANCE_VIEW_FULFILLED":
                return {
                    ...state,
                    loadingPharmacyView: false,
                    changedPharmacyStatusView: action.payload,
                    //pharmacyIdsView:action.payload?.data?.id  || state.pharmacyIdsView,
                errorsPharmacyView: {},
                };
        case "UPDATE_PHARMACY_VIEW_FULFILLED":
            return {
                ...state,
                loadingPharmacyView: false,
                changedPharmacyStatusView: action.payload,
                //pharmacyIdsView:action.payload?.data?.id  || state.pharmacyIdsView,
                errorsPharmacyView: {},
            };

        case "UPDATE_PHARMACY_STATUS_VIEW_FULFILLED":
            return {
                ...state,
                loadingPharmacyView: false,
                changedPharmacyStatusView: action.payload,
            };

        case "GET_PHARMACYLISTBYID_VIEW_FULFILLED":
            return {
                ...state,
                loadingPharmacyView: false,
                pharmacyListsIdView: action.payload
            };

        case "DELETE_PHARMACY_VIEW_FULFILLED":
            return {
                ...state,
                loadingPharmacyView: false,
                changedPharmacyStatusView: action.payload
            };

        case "RESET_DELETE_PHARMACYS_STATUS_VIEW":
            console.log("RESET_DELETE_PHARMACYS_STATUS_VIEW");
            return {
                ...state,
                loadingPharmacyView: false,
                changedPharmacyStatusView: [],
                errorsPharmacyView:{},
                //pharmacyIdsView:"",
                pharmacyViewDetailsView:[],
            };

        case "GET_PHARMACYLIST_VIEW_REJECTED":
        case "ADD_PHARMACY_BASIC_VIEW_REJECTED":
        case "ADD_PHARMACY_DL_VIEW_REJECTED":
        case "ADD_PHARMACY_OWNER_VIEW_REJECTED":
        case "ADD_PHARMACIST_VIEW_REJECTED":
        case "ADD_GST_PAN_VIEW_REJECTED":
        case "ADD_LOCATED_HOSPITAL_VIEW_REJECTED":
        case "ADD_PHARMACY_AlERT_VIEW_REJECTED":
        case "ADD_BACK_LIST_VIEW_REJECTED":
        case "ADD_GRIEVANCE_VIEW_REJECTED":
        case "UPDATE_PHARMACY_BASIC_VIEW_REJECTED":
        case "UPDATE_PHARMACY_VIEW_REJECTED":
        case "UPDATE_PHARMACY_STATUS_VIEW_REJECTED":
        case "DELETE_PHARMACY_VIEW_REJECTED":
        case "GET_PHARMACYLISTBYID_VIEW_REJECTED":
        case "GET_PHARMACYVIEWLISTBYID_VIEW_REJECTED":
            return {
                ...state,
                loadingPharmacyView: false,
                errorsPharmacyView: action.payload
            };

        default:
            return state;
    }
}

export default pharmacyReducerView;